import { motion } from "framer-motion";
import { Backdrop } from "@/components/eclipsia/Backdrop";
import { BookingForm } from "@/components/eclipsia/BookingForm";
import { Logo } from "@/components/eclipsia/Logo";
import { SiteFooter } from "@/components/eclipsia/SiteFooter";
import { SoldOutNotice } from "@/components/eclipsia/SoldOutNotice";
import { useConfig } from "@/hooks/useConfig";
import { formatDateIt } from "@/lib/api";

export default function Prenota() {
  const { config, loaded } = useConfig();
  const date = formatDateIt(config.eventDate);
  const t = config.texts;

  return (
    <main className="relative min-h-screen w-full overflow-hidden bg-black flex flex-col" data-testid="prenota-page">
      <div className="fixed inset-0"><Backdrop images={config.formBgImages} video={config.heroVideo} /><div className="absolute inset-0 z-[2] bg-black/30" /></div>
      <div className="relative z-10 flex flex-col flex-1 min-h-screen">
        <Logo className="h-16 md:h-20" />
        <div className="flex-1 flex justify-center px-6 py-10">
          <div className="w-full max-w-md">
            {loaded && (config.soldOut ? <SoldOutNotice dateLong={date.long} title={t.soldOutTitle} /> : (
              <>
                <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="text-center mb-8">
                  <p className="text-xs tracking-[0.3em] uppercase text-white/70 font-body font-medium mb-3">{t.prenotaEyebrow}</p>
                  <h1 data-testid="prenota-date" className="font-heading italic font-normal text-white text-5xl md:text-6xl tracking-[-2px]">{date.long}</h1>
                  <p className="mt-3 text-sm text-white/50 font-body">{t.prenotaSubline}</p>
                </motion.div>
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}>
                  <BookingForm liste={config.liste} dateLong={date.long} successTitle={t.successTitle} />
                </motion.div>
              </>
            ))}
          </div>
        </div>
        <SiteFooter delay={0.6} />
      </div>
    </main>
  );
}
